import React from "react";
import { Container } from "react-bootstrap";
import {
  Heading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";
import "swiper/css";
import { Link } from "react-router-dom";
import styles from "./recent.module.css";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const Highlights = () => {
  return (
    <React.Fragment>
      <Container>
        <div className={styles.mainSection}>
          <Heading>Recent Highlights</Heading>
          <Paragraph color="#62677A">
            Stay informed with the latest developments in global trade and
            industries <br /> related to our business.
          </Paragraph>

          {/* -------------slider-section------------ */}
<h6>Recent News:</h6>
          <Swiper
            slidesPerView={2.5}
            spaceBetween={30}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="mySwiper"
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 2.5,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 2.5,
                spaceBetween: 40,
              },
            }}
          >
            <SwiperSlide>
              <div className={styles.cards}>
                <img
                  loading="lazy"
                  src="/images/news/cold.png"
                  alt="windwill"
                />
                <h2>India Ramps Up Solar Energy Projects</h2>
                <p>
                  "With plans for 50 solar parks and 500 GW of renewable energy
                  by 2030, India is setting the stage for a greener future."
                </p>
                <Link to='#'>Read More</Link>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.cards}>
                <img
                  loading="lazy"
                  src="/images/news/coal.png"
                  alt="windwill"
                />
                <h2>Commodities and Resources</h2>
                <p>
                  Efficient sourcing and delivery of coal, minerals, and
                  precious metals.
                </p>
                <Link to='#'>Read More</Link>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className={styles.cards}>
                <img
                  loading="lazy"
                  src="/images/news/dubai.webp"
                  alt="windwill"
                />
                <h2>Technology intergration </h2>
                <p>
                  IoT-enabled monitoring systems for <br /> energy projects.
                </p>
                <Link to='#'>Read More</Link>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default Highlights;
